import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import ZoneButton from './ZoneButton';
import ZoneButtonsWrapper from './ZoneButtonsWrapper';
import {
  getRelativeHeight,
  getRelativeWidth,
} from '../../components/CardReader/CardReader';

const ButtonABC = styled(ZoneButton)`
  margin-top: 11%;
  width: 53%;
`;

const ButtonABCD = styled(ZoneButton)`
  width: 71%;
`;

const ButtonBC = styled(ZoneButton)`
  margin-left: 17%;
  height: ${getRelativeHeight(143)};
  width: 37%;
`;

const DownButtonWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  top: ${getRelativeHeight(-220)};
  left: ${getRelativeHeight(0)};
  height: ${getRelativeHeight(88)};
  width: ${getRelativeWidth(390)};
`;

const DownButton = styled(ZoneButton)`
  height: ${getRelativeHeight(148)};
  width: ${getRelativeWidth(65)};
  cursor: pointer;
`;

const ZoneButtonsC = ({
  onClickZoneABC,
  onClickZoneABCD,
  onClickZoneBC,
  onClickDownButton,
}) => (
  <ZoneButtonsWrapper>
    <ButtonABC onClick={onClickZoneABC} />
    <ButtonABCD onClick={onClickZoneABCD} />
    <DownButtonWrapper>
      <ButtonBC onClick={onClickZoneBC} />
      <DownButton onClick={onClickDownButton} />
    </DownButtonWrapper>
  </ZoneButtonsWrapper>
);

ZoneButtonsC.propTypes = {
  onClickZoneABC: PropTypes.func.isRequired,
  onClickZoneABCD: PropTypes.func.isRequired,
  onClickZoneBC: PropTypes.func.isRequired,
  onClickDownButton: PropTypes.func.isRequired,
};

export default ZoneButtonsC;
